


















import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'v-file-upload' })
export default class VFileUpload extends Vue {
    fileName: string = ''

    changeFiles(files: FileList) {
        const file = files.length > 0 ? files[0] : undefined
        this.$emit('input', file)
        this.fileName = file ? file.name : ''
    }
}
